import { useEffect, useMemo } from 'react'
import { useAuth } from 'react-oidc-context'
import { createClientRegistry, stopClientRegistry } from './clients/createClientRegistry'
import { Vulcan } from './components/vulcan/Vulcan'
import { type GatewayDefinition, VULCAN_GATEWAYS } from './configuration/gateways'

export function App({ gateway }: { gateway: GatewayDefinition }) {
  const auth = useAuth()
  const clients = useMemo(
    () => createClientRegistry(VULCAN_GATEWAYS, () => auth.user?.access_token, gateway),
    [auth.user?.access_token, gateway]
  )
  useEffect(() => () => stopClientRegistry(clients), [clients])
  return <Vulcan clients={clients} />
}
